module.exports = __webpack_public_path__ + "img/Ind-flg.c7842dfd.png";